// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_tz-0";